import { useEffect } from 'react';
import { toast } from 'react-hot-toast';

import { ResponseError } from '../../lib/flotiq-client/response-errors';

/**
 * Decides whether to show api response error in toasts.
 */
const useApiErrorsToast = (error: any) => {
  useEffect(() => {
    const errors = Array.isArray(error) ? error : [error];
    if (!errors?.length) return;
    errors
      .filter((er) => er instanceof ResponseError)
      .forEach((error) => {
        toast.error(error.message);
      });
  }, [error]);
};

export default useApiErrorsToast;
